/**
 * Create and initialise Tako tables
 */

/* -----------------------------------------------------------------------------
 * Tako Table
 * -------------------------------------------------------------------------- */
import { getLogger } from './utils/logger-context';
import { resolveComponentScope } from './utils/resolveComponentScope';

const COMPONENT_NAME = 'Table';

export const init = (unresolvedScope) => {
    const logger = getLogger();
    const scope = resolveComponentScope(unresolvedScope);
    const allTakoTables = scope.querySelectorAll('.tako-table');
    const defaultLoggerArgs = {
        componentName: COMPONENT_NAME,
        scope,
    };
    logger.debug(`Initialising ${COMPONENT_NAME} component.`, { scope });

    allTakoTables.forEach((takoTable) => {
        try {
            const instanceLoggerArgs = {
                ...defaultLoggerArgs,
                element: takoTable,
            };
            // ToDo: Remove tako-table--selectable with the next breaking change
            const selectableCells = takoTable.querySelectorAll(
                '[data-table-selectable], .tako-table--selectable',
            );

            const handleCellSelect = (event) => {
                event.target.classList.toggle('tako-table--selected');
                // Update aria-pressed to reflect selection state
                const isSelected = event.target.classList.contains(
                    'tako-table--selected',
                );
                event.target.setAttribute('aria-pressed', isSelected);
            };

            const handleKeyDown = (event) => {
                // Handle Enter and Space keys for selection
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    handleCellSelect(event);
                }
            };

            /**
             * tako-table--selectable class is @deprecated
             */
            const selectableTableWithLegacyClass = takoTable.querySelectorAll(
                '.tako-table--selectable',
            );

            if (selectableTableWithLegacyClass.length) {
                logger.warn(
                    'The `tako-table--selectable` class is deprecated. Please use the `data-table-selectable` attribute instead.',
                    instanceLoggerArgs,
                );
            }

            selectableCells.forEach((cell) => {
                // Make cell keyboard accessible
                cell.setAttribute('tabindex', '0');
                cell.setAttribute('role', 'button');

                // Add aria-label if not already present, using the text inside of the cell
                if (!cell.getAttribute('aria-label')) {
                    const cellText = cell.textContent?.trim() || 'cell';
                    cell.setAttribute('aria-label', `Select ${cellText}`);
                }

                // Add event listeners
                cell.addEventListener('click', handleCellSelect);
                cell.addEventListener('keydown', handleKeyDown);
            });
        } catch (error) {
            logger.error(error, {
                ...defaultLoggerArgs,
                element: takoTable,
            });
        }
    });
};
